import React, {useCallback, useEffect, useState} from 'react';

import {getAccountTemplateUsers} from 'src/openapi/admin/apis/GetAccountTemplateUsersApi';
import {useAppDispatch} from 'src/store/hooks';

import {Input} from '@pb/kit-component-input-v2';


import {SearchTemplateUser as SearchTemplateUserComponent} from './search-template-user';

import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

type Props = {
    onSelect: (user: UserShortInfo | undefined) => void,
    accountId: number,
    onFieldChange: (fieldName: string) => void,
};

export const SearchTemplateUser = ({onSelect, accountId, onFieldChange}: Props) => {
    const [list, setList] = useState<Array<UserShortInfo>>();
    const [user, setUser] = useState<UserShortInfo>();
    const apiDispatch = useAppDispatch();

    const getListOfAllTemplateUsers = useCallback(async () => {
        if (list?.length) {
            return Promise.resolve(list);
        }

        const response = await apiDispatch(getAccountTemplateUsers({accountId}));
        if (response.payload.success) {
            setList(response.payload.data);
            return response.payload.data;
        }

        return [] as Array<UserShortInfo>;
    }, [accountId, list, apiDispatch]);

    useEffect(() => {
        const selectFirstTemplateUser = async () => {
            const res = await getListOfAllTemplateUsers();
            setUser(res[0]);
            onSelect(res[0]);
        };
        selectFirstTemplateUser();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const onTrackFieldChange = useCallback(() => {
        onFieldChange('Import alerts & layouts from user');
    }, [onFieldChange]);

    const selectUser = useCallback((value: UserShortInfo | undefined) => {
        onSelect(value);
        onTrackFieldChange();
    }, [onSelect, onTrackFieldChange]);

    if (!user) {
        return (
            <Input width={315} disabled={true}/>
        );
    }

    return (
        <SearchTemplateUserComponent
            width={315}
            label="Import alerts & layouts from user"
            selectedTemplateUser={user}
            placeholder="Do not import"
            onSelect={selectUser}
            accountId={+accountId}
        />
    );
};
